module.exports = __webpack_public_path__ + "static/img/fbiotic-product.ecccc073.jpg";